import { CommonModule } from '@angular/common';
import { Component, inject, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { DateFormat } from '@lx/shared/i18n';
import { DatePipe } from '@lx/shared/ui/pipes';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { map, Observable } from 'rxjs';
import { CompanyEnum } from '../../models/company.model';
import { PriceListPublicHolidays } from '../../models/pricelist-public-holiday.model';
import { SharedDataStore } from '../../store';
import { HeaderFlagComponent } from '../header-flag/header-flag.component';
import { PriceListPanelComponent } from '../price-list-panel/price-list-panel.component';

@Component({
  selector: 'lx-price-lists-portal-public-holidays',
  standalone: true,
  imports: [CommonModule, ProgressSpinnerModule, DatePipe, HeaderFlagComponent, PriceListPanelComponent],
  templateUrl: './public-holidays.component.html',
  styleUrls: ['./public-holidays.component.scss', './print-public-holidays.component.scss'],
})
export class PublicHolidaysComponent implements OnChanges, OnInit {
  @Input() countryCode: string | undefined;

  dateFormat = DateFormat.SHORT_MONTH_NAME;
  publicHolidays$: Observable<PriceListPublicHolidays> | undefined;

  // Public holidays have the style of KIL always
  company = CompanyEnum.KIL;

  private readonly sharedDataStore = inject(SharedDataStore);

  ngOnChanges({ countryCode }: SimpleChanges): void {
    if (countryCode.currentValue) {
      this.publicHolidays$ = this.sharedDataStore.publicHolidays$.pipe(
        map((publicHolidays) => ({
          christmasClosureHolidays: publicHolidays.christmasClosureHolidays.filter((holiday) => holiday.country.code === countryCode.currentValue),
          countryPublicHolidays: publicHolidays.countryPublicHolidays.filter((holiday) => holiday.country.code === countryCode.currentValue),
        })),
      );
    }
  }

  ngOnInit(): void {
    if (!this.countryCode) {
      this.publicHolidays$ = this.sharedDataStore.publicHolidays$;
    }
  }
}
